import React from 'react';
import theme from './ExternalAgreementApproveWizard.module.scss';

import { ValidationScope } from '@/components/forms/validation';
import { useValidationManager } from '@/utils/hooks';
import ChangeRequestOverrideOptionSelect from '@/seller/components/change-requests/ChangeRequestOverrideOptionSelect';
import { Trans } from '@lingui/react/macro';
import InfoIconWithTooltip from '@/seller/components/InfoIconWithTooltip';
import { OptionGroupOverrideSelection } from '@/types';

interface ExternalAgreementApproveWizardOverrideOptionsProps {
    residentialUnitId: number;
    value: OptionGroupOverrideSelection[];
    onChange(data: OptionGroupOverrideSelection[]): void;
}

const ExternalAgreementApproveWizardOverrideOptions: React.FC<ExternalAgreementApproveWizardOverrideOptionsProps> = ({
    residentialUnitId,
    value,
    onChange,
}) => {
    const validationManager = useValidationManager();

    return (
        <ValidationScope validationManager={validationManager}>
            <p>
                <Trans>
                    Please make sure that all options that should be overridden by this change request have been selected.
                </Trans>
            </p>
            <div className={theme.smallHeader}>
                <Trans>Select buyer options to override</Trans>

                <InfoIconWithTooltip
                    color="light"
                    title={<Trans>Select buyer options to override</Trans>}
                    content={
                        <Trans>
                            If this offer overrides any of the buyer options listed below, please select them, so that they
                            don’t appear as possible options to the buyer.
                        </Trans>
                    }
                />
            </div>
            <ChangeRequestOverrideOptionSelect residentialUnitId={residentialUnitId} value={value} onChange={onChange} />
        </ValidationScope>
    );
};

export default ExternalAgreementApproveWizardOverrideOptions;